import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import {
  ChecklistTemplateVersionMessages,
  MessageDesignBUtils
} from '../../content/components/message-design-b/message-design-b.utils';
import { calcDefaultTimeoutOf, RequestClientService } from '../../services/client/request-client.service';
import {
  ChecklistTemplateVersionAction
} from '../../states/checklist-template-version/checklist-template-version.action';
import { MessageModel } from '../../content/components/message-design-b/message.model';

export class SseChecklistTemplateActionEvent extends SseEventBase {

  type: SseEventType = 'checklistTemplateAction';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.CHECKLIST_TEMPLATE_ACTION_REPLACE_REFERENCES_SUCCESS: {
          const start: number = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            const message: MessageModel = MessageDesignBUtils.checklistTemplateActionReplaceReferencesSuccess();
            this.on.inProgressAsyncWorkFinished$.next(message);
          }, calcDefaultTimeoutOf(new Date(start)));
          break;
        }
        case NotificationReasonEnum.CHECKLIST_TEMPLATE_ACTION_REPLACE_REFERENCES_FAILED: {
          const start: number = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            const message: MessageModel = MessageDesignBUtils.checklistTemplateActionReplaceReferencesFailed();
            this.on.inProgressAsyncWorkFinished$.next(message);
          }, calcDefaultTimeoutOf(new Date(start)));
          break;
        }
      }
    });
  }
}
